/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';
import type { WorkConditions } from './';
import {
    WorkConditionsFromJSON,
    WorkConditionsFromJSONTyped,
    WorkConditionsToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkConditionsField
 */
export interface WorkConditionsField extends UpdatedField {
    /**
     * 
     * @type {WorkConditions}
     * @memberof WorkConditionsField
     */
    workConditions: WorkConditions;
}

/**
 * Check if a given object implements the WorkConditionsField interface.
 */
export function instanceOfWorkConditionsField(value: object): value is WorkConditionsField {
    if (!('workConditions' in value) || value['workConditions'] === undefined) return false;
    return true;
}

export function WorkConditionsFieldFromJSON(json: any): WorkConditionsField {
    return WorkConditionsFieldFromJSONTyped(json, false);
}

export function WorkConditionsFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkConditionsField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'workConditions': WorkConditionsFromJSON(json['workConditions']),
    };
}

export function WorkConditionsFieldToJSON(value?: WorkConditionsField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'workConditions': WorkConditionsToJSON(value['workConditions']),
    };
}

